import React from "react"
import { canDebug } from "../components/LogManagement/logManagement"

const defaultState = {
  token: '',
  handleTokenChange: () => {},
}
const TokenContext = React.createContext(defaultState);
const useTokenContext = () => React.useContext(TokenContext);
//console.log("useTokenContext:", useTokenContext);

const TokenProvider = ({ children }) => {
  const [token, setToken] = React.useState(defaultState.token);

  const handleTokenChange = (newToken) => {
    if (newToken !== token){
      canDebug('TokenProvider') && console.log("Set Token", newToken, "old token:", token);
      setToken(newToken);
    }
  }

  //console.log('Token Provider: ', token);
  return <TokenContext.Provider value={{ token, handleTokenChange }} >
    {children}
  </TokenContext.Provider>
}

export default TokenProvider;
export { useTokenContext };
